module.exports = __webpack_public_path__ + "da9b3220c1fe94b6ebdc4b03e69b165e.svg";